<template>
  <div>
    <base-button block type="primary" class="m-0" @click="modal = true" :disabled="creationDisabled">
      {{ $t('pt_locks.create.btnLabel') }}
    </base-button>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('pt_locks.create.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('pt_locks.create.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('pt_locks.form.operator_id') }}</label>
            <div class="col-md-9">
              <base-input>
                <el-select
                  class="select-primary"
                  name="operator"
                  v-model="formDetails.operator_id"
                >
                  <el-option
                    v-for="option in operators"
                    class="select-primary"
                    :value="option.id"
                    :label="option.id"
                    :key="option.id"
                  >
                    <span>{{ option.name }} ({{ option.id }})</span>
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-3 col-form-label">{{ $t('pt_locks.form.garage_number') }}</label>
            <div class="col-md-9">
              <base-input
                data-vv-as="'garage_number'"
                name="garage_number"
                v-validate="modelValidations.required"
                :error="getError('garage_number')"
                v-model="formDetails.garage_number"
                step="0.01"/>
            </div>
          </div>
          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('pt_locks.create.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {DatePicker, Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'create-lock',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    Modal,
    BaseAlert
  },
  props: {
    creationDisabled: {
      type: Boolean,
      required: false,
    },
    operators: {
      type: Array,
      required: true,
    },
    teamId: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      modal: false,
      alert: false,
      loading: false,
      formDetails: {
        operator_id: '',
        garage_number: ''
      },
      modelValidations: {
        required: {
          required: true
        }
      }
    }
  },

  computed: {
    ...mapState({
      updating: state => state.pt_locks.updating,
      error: state => state.pt_locks.error,
      createdLock: state => state.pt_locks.createdLock,
      ptMappings: state => state.pt_mapping.data,
    }),
    getActionErrorDetails() {
      if (this.error) {
        return this.error.bodyText ? this.error.bodyText : this.error;
      }
      return null;
    }
  },
  methods: {
    ...mapActions(['CreatePtLock', 'LoadInspectorTeamPtLocks']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    create: function () {
      let payload = {
        inspector_team_id: this.teamId,
        data: {
          operator_id: this.formDetails.operator_id,
          garage_number: this.formDetails.garage_number
        }
      }

      this.CreatePtLock(payload).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('pt_locks.create.createdNotification', {
              mapping_id: this.createdLock.mapping_id
            }),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.LoadInspectorTeamPtLocks(this.teamId);
          this.resetForm();
        }
      });
    },
    resetForm: function () {
      // closing dialog
      this.modal = false;

      // resetting alerts
      this.alert = false;

      // resetting form
      this.formDetails = {
        operator_id: '',
        garage_number: ''
      };

      // reset validation errors
      this.$validator.reset()
    }
  }
}
</script>
